export default {
  metadata: {
    version: '1.0.0',
    id: 'Input-code-item-1.0.0',
    name: 'JDSInputCodeItem'
  },
  hierarchy: {
    'input-container': [
      'jds_input',
      {
        'active-line-container': ['feedback-container']
      }
    ]
  },
  base: {
    'input-container': {
      'flex-direction': '{i_0}',
      'justify-content': '{i_1}',
      'align-items': '{i_2}',
      gap: '{i_3}',
      width: '{i_4}',
      behavior: {
        hover: {}
      }
    },
    jds_input: {
      width: '{i_5}',
      type: 'number',
      textAlign: 'center',
      textSize: 'large',
      maxLength: 1
    },
    'active-line-container': {
      'flex-direction': '{i_6}',
      'justify-content': '{i_7}',
      'align-items': '{i_8}',
      width: '{i_9}',
      'padding-top': '{i_10}',
      'padding-bottom': '{i_11}'
    },
    'feedback-container': {
      width: '{i_12}',
      height: '{i_13}',
      'background-color': '{i_14}',
      'border-radius': '{i_15}',
      show: true,
      behavior: {
        hover: {
          'background-color': '{i_16}'
        },
        focus: {
          'background-color': '{i_17}'
        },
        active: {
          'background-color': '{i_18}'
        }
      }
    }
  },
  variant: {
    state: {
      success: {
        'feedback-container': {
          'background-color': '{i_19}'
        }
      },
      error: {
        'feedback-container': {
          'background-color': '{i_20}'
        }
      },
      warning: {
        'feedback-container': {
          'background-color': '{i_21}'
        }
      }
    },
    disabled: {
      true: {
        jds_input: {
          disabled: true
        }
      }
    },
    secureText: {
      true: {
        jds_input: {
          type: 'pin'
        }
      }
    }
  },
  combination: [
    {
      none: {
        true: {
          'feedback-container': {
            'background-color': '{i_22}'
          }
        }
      }
    }
  ],
  combination_config: [['state', '_inputFocus']],
  api: {
    config: {
      secureText: {
        values: [false, true]
      },
      state: {
        type: 'JDSFeedbackBlock.state',
        values: ['none', 'success', 'error', 'warning']
      },
      _inputFocus: {
        values: [false, true]
      },
      disabled: {
        values: [false, true]
      }
    },
    data: {
      jds_input: {
        value: {
          type: 'string',
          name: 'value'
        },
        placeholder: {
          type: 'string',
          name: 'placeholder'
        },
        required: {
          type: 'boolean',
          name: 'required'
        },
        focusRequester: {
          type: 'focusRequester',
          name: 'focusRequester',
          platform: 'android'
        }
      }
    },
    events: {
      jds_input: {
        onFocus: 'onFocus',
        onBlur: 'onBlur',
        onChange: 'onChange',
        onSubmit: 'onSubmit',
        onKeydown: {
          name: 'onKeydown',
          platform: 'web'
        },
        onPaste: 'onPaste',
        onInvalid: 'onInvalid'
      }
    }
  }
};
